'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      scrolled ? 'bg-surface/80 backdrop-blur-xl py-3 shadow-sm' : 'bg-transparent py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-lg flex justify-between items-center">
        <Link href="/" className="text-h2 text-primary font-playfair font-bold">
          Eliz Ateliê
        </Link>
        
        <nav className="hidden md:flex items-center gap-xl">
          <Link href="#inicio" className="text-button text-on-surface hover:text-primary transition-colors">Início</Link>
          <Link href="#quem-somos" className="text-button text-on-surface hover:text-primary transition-colors">Quem Somos</Link>
          <Link href="#servicos" className="text-button text-on-surface hover:text-primary transition-colors">Serviços</Link>
          <Link href="#aluguel" className="text-button text-on-surface hover:text-primary transition-colors">Aluguel</Link>
          <Link href="#contato" className="text-button text-on-surface hover:text-primary transition-colors">Contato</Link>
        </nav>

        <div className="flex items-center gap-md">
          <Link 
            href="#contato"
            className="bg-primary text-on-primary px-lg py-sm rounded-xl text-button hover:brightness-110 transition-all ambient-shadow"
          >
            Agendar
          </Link>
        </div>
      </div>
    </header>
  );
}
